import { useState } from "react";
import { ArrowRight } from "lucide-react";
import { subscribe } from "@/lib/api";

export const SignupForm = ({ source = "home", testid = "signup" }) => {
  const [email, setEmail] = useState("");
  const [state, setState] = useState({ status: "idle", message: "" });

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!/^[^@\s]+@[^@\s]+\.[a-zA-Z]{2,}$/.test(email.trim())) {
      setState({ status: "error", message: "That email looks sus. Try again?" });
      return;
    }
    setState({ status: "loading", message: "" });
    try {
      const r = await subscribe({ email, source });
      setState({ status: r.status, message: r.message, pack: r.pack_url });
    } catch (err) {
      setState({ status: "error", message: err.response?.data?.detail || "Something went sideways. Try again." });
    }
  };

  if (state.status === "subscribed" || state.status === "exists")
    return (
      <div className="border-t border-ink pt-5" data-testid={`${testid}-success`} role="status">
        <p className="text-lg font-medium">{state.message}</p>
        <p className="label mt-2 text-ink/60">{state.status === "exists" ? "We already have you on the list" : "See you before the next drop"}</p>
        {state.pack && <a href={state.pack} className="btn btn-pink mt-5" data-testid={`${testid}-pack-download`}>Download your sticker pack</a>}
      </div>
    );

  return (
    <form onSubmit={onSubmit} noValidate className="w-full" data-testid={`${testid}-form`}>
      <label htmlFor={`${testid}-email`} className="sr-only">Email address</label>
      <div className="flex overflow-hidden rounded-[12px] border-[1.5px] border-ink">
        <input
          id={`${testid}-email`}
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Enter your email"
          autoComplete="email"
          className="h-14 flex-1 bg-transparent font-mono text-sm text-ink placeholder:text-ink/45 focus:outline-none"
          data-testid={`${testid}-email-input`}
        />
        <button type="submit" disabled={state.status === "loading"} aria-label="Subscribe" className="mb-2 flex h-12 w-12 items-center justify-center bg-ink text-cloud transition-colors hover:bg-[#2b2b2b] disabled:opacity-40" data-testid={`${testid}-submit-button`}>
          <ArrowRight size={18} strokeWidth={1.5} />
        </button>
      </div>
      {state.status === "error" && (
        <p className="mt-3 font-mono text-xs text-alert" data-testid={`${testid}-error`} role="alert">{state.message}</p>
      )}
    </form>
  );
};
